// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"jS-z","inlineTitle":"kS-z","sponsoredAdsWrapper":"lS-z","marketplaceRecosWrapper":"mS-z"};